import { useState } from "react";
import { ButtonPopup } from "../ui";
import { useNavigate } from "react-router-dom";

interface PopupEditarAfiliadoProps {
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  titulo?: string;
  descripcion?: string;
  descripcionValidacion?: string;
  textoConfirmar?: string;
  textoCancelar?: string;
  redirectOnConfirm?: boolean; // 👈 NUEVO
}

const PopupEditarAfiliado: React.FC<PopupEditarAfiliadoProps> = ({
  onConfirm,
  onCancel,
  titulo = "Editar Afiliado",
  descripcion = "Esta acción modificará los datos del afiliado.",
  descripcionValidacion = "¿Deseas confirmar esta acción?",
  textoConfirmar = "Confirmar",
  textoCancelar = "Cancelar",
  redirectOnConfirm = true, // 👈 por defecto sí
}) => {
  const [step, setStep] = useState<"confirm" | "validate">("confirm");
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  const handleConfirmStep = () => setStep("validate");

  const handleExecute = async () => {
    try {
      await onConfirm();
      if (redirectOnConfirm) {
        navigate("/afiliados");
      }
    } catch (err: any) {
      console.error(err);
      alert("Error al realizar la acción");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="bg-white rounded-xl p-6 w-80 text-center shadow-lg dark:text-zinc-700">

        {step === "confirm" && (
          <>
            <h2 className="text-lg font-semibold mb-4">{titulo}</h2>
            <p className="mb-6">{descripcion}</p>

            <div className="flex justify-center gap-4">
              <ButtonPopup
                onClick={handleConfirmStep}
                className="border-blue-700 hover:border-2 hover:shadow-blue-700"
              >
                Sí
              </ButtonPopup>

              <ButtonPopup
                onClick={onCancel}
                className="border-red-700 hover:border-2 hover:shadow-red-700"
              >
                {textoCancelar}
              </ButtonPopup>
            </div>
          </>
        )}

        {step === "validate" && (
          <>
            <h2 className="text-lg font-semibold mb-4">Confirmar acción</h2>
            <p className="mb-6">{descripcionValidacion}</p>

            <div className="flex justify-center gap-4">
              <ButtonPopup
                onClick={handleExecute}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                className="border-red-700 hover:border-2 hover:shadow-red-700"
              >
                {hovered ? textoConfirmar : "¿Seguro?"}
              </ButtonPopup>

              <ButtonPopup
                onClick={onCancel}
                className="border-blue-700 hover:border-2 hover:shadow-blue-700"
              >
                {textoCancelar}
              </ButtonPopup>
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default PopupEditarAfiliado;
